/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createSessionExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import { type SessionStorage, PERSIST_KEY } from './types.tsx';

const crossProjectBoardTraitSessionProvider = createSessionExpirableStorageProvider(PERSIST_KEY);

export const crossProjectBoardTraitSessionStorageProvider = (): {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	get: () => any;
	persist: (toPersist: SessionStorage) => void;
} => {
	const persist = (toPersist: SessionStorage): void => {
		// @browser-storage setter
		crossProjectBoardTraitSessionProvider.set(PERSIST_KEY, toPersist);
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const get = (): any => crossProjectBoardTraitSessionProvider.get(PERSIST_KEY);

	return { get, persist };
};
